import { useEffect, useState } from "react"

const useSearchParams = () => {
  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(window.location.search)
  )

  useEffect(() => {
    const updateSearchParams = () => {
      setSearchParams(new URLSearchParams(window.location.search))
    }

    window.addEventListener("popstate", updateSearchParams)

    return () => {
      window.removeEventListener("popstate", updateSearchParams)
    }
  }, [])

  const updateSearchParam = (name: string, value: string) => {
    const params = new URLSearchParams(searchParams)
    params.set(name, value)

    const newUrl = `${window.location.pathname}?${params.toString()}`
    window.history.pushState({ path: newUrl }, "", newUrl)

    setSearchParams(params)
  }

  const removeSearchParam = (name: string) => {
    const params = new URLSearchParams(searchParams)
    params.delete(name)

    const newUrl = `${window.location.pathname}?${params.toString()}`
    window.history.pushState({ path: newUrl }, "", newUrl)

    setSearchParams(params)
  }

  const navigateWithSearchParam = ({ search }: { search: string }) => {
    const newUrl = `${window.location.pathname}${search && "?"}${search}`
    window.history.pushState({ path: newUrl }, "", newUrl)

    setSearchParams(new URLSearchParams(search))
  }

  return {
    searchParams,
    updateSearchParam,
    removeSearchParam,
    navigateWithSearchParam
  }
}

export default useSearchParams
